import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

export default  makeStyles(theme => ({
  bannerContainer: {
    height: '100vh',
    width: '100vw',

    // parallex
    // position: 'fixed',
    // top: 0
  //  transform: 'translateZ(-200px) scale(3) translateY(-100px)'

  },
  bgVideo: {
    right: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    objectFit: 'cover'
  },
  bgVideoOverlayContainer: {
    position: 'absolute',
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.4)',
    color: '#f1f1f1',
    width: '100%',
    height: '100%',
    // padding: 20
  },
  bannerText: {
    display: 'flex',
    justifyContent: 'space-around',
    height: '100%',
    textShadow: '1px 1px 2px black',
    '& *' : {
      margin: 'auto',
    //  width: '90%',
      textAlign: 'center',
      fontWeight: 'bold',
      letterSpacing: 1,
      [theme.breakpoints.down("sm")]: {
      //  width: '80%',
        textAlign: 'center',
        fontSize: '2rem'
      }
    }
  },
  errorIcon: {
    color:'red',
    margin:'auto',
    textAlign:'center',
    display:'flex'

  }
}))
